  /* Extract Name from query parameter */
    const queryString = window.location.search; 
    var urlParams = new URLSearchParams(queryString); 
    var fname ="",
        lname = "";
    if (urlParams.size != 0 && urlParams.get('fname') != null && document.querySelector(".cus-name") != null){
      fname = urlParams.get('fname');
      if(urlParams.get('lname') != null && urlParams.get('lname') != "" ){
        lname =  " " + urlParams.get('lname');
      }
    }

    if(document.querySelector(".cus-name") != null){
      if(fname != ""){
        document.querySelector(".cus-name").innerHTML = fname + lname ;
      }else{
        document.querySelector(".cus-name").innerHTML = "Hi there" + lname ;
        fname = "there";
      }  
    }
    if(document.querySelector(".cus-fname") != null){
      document.querySelector(".cus-fname").innerHTML = fname ;
    }

    /* Identify Today Date */
    var toDay = new Date(),
      expTime = new Date(toDay.getTime() + (0 * 24 * 60 * 60 * 1000)),
      expMonth = expTime.toLocaleString('default', {
        month: 'long'
      }),
      expYear = expTime.getFullYear(),
      expDate = expTime.getDate();
      if(document.querySelector(".author-date") != null){
        document.querySelector(".author-date").innerHTML = expMonth + " " + expDate + ", " + expYear;
      }
    

/* ======= Change Css property value ======== */
    function cssChangeValue(s, p, v) {
      let el = document.querySelector(s);
      el.style.setProperty(p, v);
    }
/* ======= Produt Bundle switcher ======== */
    var chips = document.querySelectorAll('[name="choice_chips"]');
    for (const chip of chips) {
      chip.addEventListener("change", function() {
        let type = document.querySelector('[name="choice_chips"]:checked').value;
        if (type == "sub") {
          cssChangeValue(':root', '--sub-display', 'flex');
          cssChangeValue(':root', '--otp-display', 'none');
        } else {
          cssChangeValue(':root', '--sub-display', 'none');
          cssChangeValue(':root', '--otp-display', 'flex');
        }
      });
    }
        // document.querySelectorAll('[name="choice_chips"]')[0].addEventListener("change", function() {  
    //     let type = document.querySelector('[name="choice_chips"]:checked').value; 
    //     if(type == "sub"){
    //       cssChangeValue(':root','--sub-display', 'flex');
    //       cssChangeValue(':root','--otp-display', 'none');
    //     }
    //   });
    //   document.querySelectorAll('[name="choice_chips"]')[1].addEventListener("change", function() {  
    //     let type = document.querySelector('[name="choice_chips"]:checked').value; 
    //     if(type == "otp"){
    //       cssChangeValue(':root','--otp-display', 'flex');
    //       cssChangeValue(':root','--sub-display', 'none');
    //     }
    //   });


/* ======= Custom Slider changefunction ======== */
    function changeGslide(gSlideNum, tElem) {
      var e = document.querySelectorAll(`.${tElem}`)[0];
      e.dataset.activeindex = gSlideNum;
      Array.from(e.children).forEach((elem, i) => {
        if (i == gSlideNum) {
          elem.classList.add("active");
        } else {
          elem.classList.remove("active");
        }
        document.querySelectorAll("." + tElem + " .cntrl-btn")[i].classList.remove("active");
      });
      document.querySelectorAll("." + tElem + " .cntrl-btn")[gSlideNum].classList.add("active");
    }

    function gNext(tElem) {
      let e = document.querySelectorAll(`.${tElem}`)[0],
        i = e.dataset.activeindex,
        l = e.children.length;
      i++
      if (i > l - 1) {
        i = 0;
      };
      changeGslide(i, tElem);
    }

    function gPrev(tElem) {
      let e = document.querySelectorAll(`.${tElem}`)[0],
        i = e.dataset.activeindex,
        l = e.children.length;
      i--
      if (i < 0) {
        i = l - 1;
      };
      changeGslide(i, tElem);
    }
/* ======= individual slide change ======== */
    function gslidebtnChange() {
      let elm = event.srcElement
      changeGslide(elm.dataset.gslidebtn, elm.parentElement.dataset.gslide);
    }
/* ======= change slide on touch swap ======== */
let initialX = null;
let initialY = null;
function touchStart(tElem) {
  initialX = tElem.touches[0].clientX;
  initialY = etElem.touches[0].clientY;
};
function touchEnd(etElem) {
  if (initialX === null) {
    return;
  }
  if (initialY === null) {
    return;
  }
  let currentX = tElem.touches[0].clientX;
  let currentY = tElem.touches[0].clientY;
  let diffX = initialX - currentX;
  let diffY = initialY - currentY;
if (Math.abs(diffX) > Math.abs(diffY)) {
    if (diffX > 0) { // swiped left
      gNext(tElem); // hooking up our next slide function
    } 
else { // swiped right
      gPrev(tElem); // hooking up our prev slide function
    }
}
  initialX = null;
  initialY = null;
  e.preventDefault();
};
/* ======= initiate touch slider swap for ======== */
// document.querySelector('.gslider2').addEventListener("touchstart", function(tElem){
//   touchStart(tElem);
// })

// document.querySelector('.gslider2').addEventListener("touchend", function(tElem){
//   touchEnd(etElem);
// })

/* ======= Hide/disply ingredients list ============*/

    // function showIngrdnts() {
    //   cssChangeValue(":root", "--ext-ingrd", "flex");
    // }
    function showIngrdnts() {
      document.querySelectorAll(".ext-ingrd").forEach((elem) => {elem.classList.toggle("hide")});
      let iTxt =  event.srcElement.innerText ;
      if(iTxt == "FULL INGREDIENTS LIST"){
        event.srcElement.innerText = "LESS INGREDIENTS LIST";
      }else{
        event.srcElement.innerText= "FULL INGREDIENTS LIST";
      }
    }

    function displayElm(el, v) {
      let l = document.querySelectorAll(el).length;
      if (l == 0) {
        document.querySelector(el).style.display = v;
      } else {
        document.querySelectorAll(el).forEach((e) => e.style.display = v)
      }
    }

    function addActiveClass(el, i) {
      let eList = document.querySelectorAll(el);
      eList.forEach((e) => e.classList.remove("active"));
      eList[i].classList.add("active");

    }
    if (document.querySelector('#add_to_cart') != null){
        document.querySelector('#add_to_cart').addEventListener('click',function(){
          this.preventDefault;
          this.innerText = " Adding...";
          let ATC = this,
              p_id = document.querySelector('[name="choice_bottle"]:checked').dataset.variantId,
              p_sub_id = document.querySelector('[name="choice_bottle"]:checked').dataset.subscriptionId,
              q = this.dataset.ref,
          pData = {
              "id": p_id,
              "quantity": 1,
              "selling_plan": p_sub_id,
              "attributes": {
                      '_ref': q
                    }
            };

          fetch('/cart/clear.js', {
                method: 'POST'
                }).then(
                  setTimeout(function(){
                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(pData)
                    }).then(
                      setTimeout(function(){
                        ATC.innerText = "ADD TO CART";
                        window.location.href="/checkout"
                      },1100)
                    ).catch((error) => {
                      console.error('Error:', error);
                    })
                  },1000)
                );

          });
    }